// ランタイム設定。ローカル開発は DEV_MODE の X-Dev-User バイパス（server/.dev.vars=DEV_MODE=true）。
// 本番では Ray of Ray ID の Bearer を使う（Phase 2 後半 / PF34）。ここは値を保存せず参照するだけ。
const env = import.meta.env as Record<string, string | undefined>;

export const config = {
  /** Phase 1 Worker のベース URL。ローカルは wrangler dev の 8787。 */
  apiBase: env.VITE_API_BASE ?? "http://localhost:8787",
  /** ローカル開発の疑似ユーザー（DEV_MODE 時のみサーバが受理）。本番は undefined。 */
  devUser: env.VITE_DEV_USER ?? (env.DEV ? "dev@example.com" : undefined),
  /** 本番ログインで使う Bearer（Phase 2 後半で接続）。今は未使用。 */
  bearer: env.VITE_BEARER,
  /**
   * Slice 5b（Sheets サーバコネクタ・B1）: drive.file アクセストークンの開発用直接指定。
   * 本番は Google OAuth + Picker（Slice 5c）で `auth/sheets-token.ts` の
   * `setSheetsToken` を呼ぶ想定。ここは実 Google トークンを手動で試すための開発用フック。
   */
  sheetsToken: env.VITE_SHEETS_TOKEN,
  /** Google Identity Services OAuth Client ID（Web クライアント）。未設定なら手動トークン貼付にフォールバック。 */
  googleOAuthClientId: env.VITE_GOOGLE_OAUTH_CLIENT_ID,
  /** Google Picker API Key。未設定なら OAuth だけ実行し、シート選択は既存 AppDefinition の spreadsheetId を使う。 */
  googlePickerApiKey: env.VITE_GOOGLE_PICKER_API_KEY,
};
